module.exports = __webpack_public_path__ + "static/media/telegram.98a0f0f7.svg";